import { render, staticRenderFns } from "./FpostgradEdit.vue?vue&type=template&id=0dcdf4a4&"
import script from "./FpostgradEdit.vue?vue&type=script&lang=js&"
export * from "./FpostgradEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports